import React from 'react';

import { SimulatorsOutputs } from '@/pages/Common/Property/tabs/SimulatorsOutputs';
import DashboardLayout from '@components/templates/layouts/Outlet/DashboardLayout';
const Error404 = React.lazy(() => import('pages/Errors/404'));

const OwnerRoutes = {
    path: '/produtor',
    element: <DashboardLayout />,
    children: [
        {
            path: 'mobile/propriedades/:propId/simulador_resultado/:entityId',
            element: <SimulatorsOutputs />
        },
        {
            path: '*',
            element: <Error404 />
        }
    ]
};

export default OwnerRoutes;
